import { lazy } from "react";
import { Route } from "../../../routes";
const MyWebsitePage = lazy(() => import("../Retail/MyWebsite"));
const BookingOnboarding = lazy(() => import("./Onboarding/index"));
const ShopInfo = lazy(
  () => import("../../../components/AdminMerchant/Retail/ShopInfo")
);
export const routes: Route[] = [
  {
    key: "booking-home-route",
    title: "Retail Onboarding",
    path: "/booking/onboarding",
    enabled: true,
    component: BookingOnboarding,
  },
  {
    key: "booking-my-website",
    title: "Booking My website",
    path: "/my-website",
    enabled: true,
    component: MyWebsitePage,
  },
  {
    key: "shop-merchant",
    title: "shop-merchant",
    path: "/shop-info",
    enabled: true,
    component: ShopInfo,
  },
  {
    key: "hotel-home-route",
    title: "Retail Onboarding",
    path: "/hotel/onboarding",
    enabled: true,
    component: BookingOnboarding,
  },
  {
    key: "hotel-my-website",
    title: "Booking My website",
    path: "/my-website",
    enabled: true,
    component: MyWebsitePage,
  },
];
